<template>
  <div id="readInfoList">
    <div class="background-white first-title">
      <span style="font-size:16px;font-weight:900">阅读信息查询</span>
       <!-- <el-select v-if="branchtypeLst.length>0"  v-model="branchtype" placeholder="请选择渠道" style="width:30%;float:right" @change="changeBranchtype()">
        <el-option  v-for="(branchtype,index) in branchtypeLst" :key="index" :label="branchtype.name" :value="branchtype.code"></el-option>
      </el-select> -->
    </div>
    <div class="item">
        <div class="item-title"  style="padding-right: 0;">信息查询详情
           <el-button type="primary" @click="exportCoursewareSummaryExcel()" class="search-btn">导出</el-button>
        </div>
        <div  class="background-white">
            <div class="title-now">
               <img src="../../../assets/train/dir.png"/>
            </div>
            <div style="float:left;line-height: 40px;">{{courseName}}</div>

             <el-button type="primary" @click="getCoursewareSummaryWithPage(true)" style=" float: right;">查询</el-button>
              <div class="search-param">
              <el-input v-model="agentName" style="width:90%" placeholder="阅读人姓名模糊查询"></el-input>

            </div>
        <div style="clear:both"></div>
        </div>
    </div>

    <div class="item">

        <div  class="background-white">
                  <el-table
                  height="500"
                  :data="tableData"
                  style="width: 100%">
                  <el-table-column
                    prop="agentName"
                    label="阅读人姓名"
                    fixed
                    align="center"
                    width="100"
                    >
                     <template slot-scope="scope">
                      <div  slot="reference" v-if="scope.row.agentName">{{scope.row.agentName}}</div>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="t2Name"
                    label="T2名称"
                    align="center"
                    width="80"
                    >
                    <template slot-scope="scope">
                      <div  slot="reference" v-if="scope.row.t2Name">{{scope.row.t2Name}}</div>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="t2Code"
                    label="T2代码"
                    width="80"
                    align="center">
                    <template slot-scope="scope">
                      <div  slot="reference" v-if="scope.row.t2Code">{{scope.row.t2Code}}</div>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="t3Name"
                    label="T3名称"
                    width="80"
                    align="center">
                     <template slot-scope="scope">
                      <div  slot="reference" v-if="scope.row.t3Name">{{scope.row.t3Name}}</div>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="t3Code"
                    label="T3代码"
                    width="80"
                    align="center">
                    <template slot-scope="scope">
                      <div  slot="reference" v-if="scope.row.t3Code">{{scope.row.t3Code}}</div>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                   <el-table-column
                    prop="t4Name"
                    label="T4名称"
                    width="80"
                    align="center">
                    <template slot-scope="scope">
                      <div  slot="reference" v-if="scope.row.t4Name">{{scope.row.t4Name}}</div>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="t4Code"
                    label="T4代码"
                    width="80"
                    align="center">
                    <template slot-scope="scope">
                      <div  slot="reference" v-if="scope.row.t4Code">{{scope.row.t4Code}}</div>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="agentCode"
                    label="销售人员业务编码/内勤人员工号"
                    width="150"
                    align="center">
                    <template slot-scope="scope">
                      <div  slot="reference" v-if="scope.row.agentCode">{{scope.row.agentCode}}</div>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                   <el-table-column
                    label="课件名"
                    align="center"
                    width="80"
                    >
                    <template slot-scope="scope">
                      <el-popover trigger="hover" v-if="scope.row.fileName" placement="top">
                        <p style="text-align:center">{{ scope.row.fileName }}</p>
                        <div slot="reference" class="name-wrapper">
                          <el-tag size="medium">{{ scope.row.fileName.substr(0,4) }}</el-tag>
                        </div>
                      </el-popover>
                      <div v-else slot="reference">-</div>
                    </template>
                  </el-table-column>
                    <el-table-column
                    prop="stateStr"
                    label="阅读状态"
                    width="80"
                    align="center">
                    <template slot-scope="scope">
                      <div  slot="reference" v-if="scope.row.stateStr">{{scope.row.stateStr}}</div>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                   <el-table-column
                   prop="previewTimeStr"
                    label="起始预览时间"
                    width="120"
                    align="center">
                    <template slot-scope="scope">
                      <el-popover trigger="hover" v-if="scope.row.previewTimeStr" placement="top">
                        <p style="text-align:center">{{ scope.row.previewTimeStr }}</p>
                        <div slot="reference" class="name-wrapper">
                          <el-tag size="medium">{{ scope.row.previewTimeStr.substr(0,10) }}</el-tag>
                        </div>
                      </el-popover>
                      <div v-else slot="reference">-</div>
                    </template>
                  </el-table-column>
                   <el-table-column
                   prop="downloadTimeStr"
                    label="下载时间"
                    width="120"
                    align="center">
                    <template slot-scope="scope">
                      <el-popover trigger="hover" v-if="scope.row.downloadTimeStr" placement="top">
                        <p style="text-align:center">{{ scope.row.downloadTimeStr }}</p>
                        <div slot="reference" class="name-wrapper">
                          <el-tag size="medium">{{ scope.row.downloadTimeStr.substr(0,10) }}</el-tag>
                        </div>
                      </el-popover>
                      <div v-else slot="reference">-</div>
                    </template>
                  </el-table-column>
                   <el-table-column
                   prop="startLearnTimeStr"
                    label="开始学习时间"
                    width="120"
                    align="center">
                    <template slot-scope="scope">
                      <el-popover trigger="hover" v-if="scope.row.startLearnTimeStr"  placement="top">
                        <p style="text-align:center">{{ scope.row.startLearnTimeStr }}</p>
                        <div slot="reference" class="name-wrapper">
                          <el-tag size="medium">{{ scope.row.startLearnTimeStr.substr(0,10) }}</el-tag>
                        </div>
                      </el-popover>
                      <div slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                    <el-table-column
                    prop="finishTimeStr"
                    label="完成时间"
                    width="120"
                    align="center">
                    <template slot-scope="scope">
                      <el-popover trigger="hover" v-if="scope.row.finishTimeStr"  placement="top">
                        <p style="text-align:center">{{ scope.row.finishTimeStr }}</p>
                        <div slot="reference" class="name-wrapper">
                          <el-tag  size="medium">{{ scope.row.finishTimeStr.substr(0,10) }}</el-tag>
                        </div>
                      </el-popover>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                    <el-table-column
                    prop="prescribedDuration"
                    label="规定学习时长"
                    width="120"
                    align="center">
                    <template slot-scope="scope">
                      <div  slot="reference" v-if="scope.row.prescribedDuration">{{scope.row.prescribedDuration}}</div>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                  prop="proccessStr"
                    label="阅读进度"
                    width="100"
                    align="center">
                    <template slot-scope="scope">
                      <div  slot="reference" v-if="scope.row.proccessStr">{{scope.row.proccessStr}}</div>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                    <el-table-column
                    prop="duration"
                    width="100"
                    label="已学习时长"
                    align="center">
                    <template slot-scope="scope">
                      <div  slot="reference" v-if="scope.row.duration || scope.row.duration==0">{{scope.row.duration}}</div>
                      <div  slot="reference" v-else>-</div>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="text-align:right">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="currentPage"
                            :page-size="pageSize"
                            layout="total, prev, pager, next, jumper"
                            :page-sizes="[10, 20, 50]"
                            :total="records">
                    </el-pagination>
                </div>
        </div>
    </div>

  </div>
</template>

<script>
import api from '@/modules/api.js'

export default {
  data () {
    return {
      agentName: '',
      pageSize: 10,
      currentPage: 1,
      records: 0, // 总条数
      tableData: [],
      courseCode: this.$route.query.courseCode,
      branchtypeLst: [],
      req: {},
      courseName: this.$route.query.courseName
    }
  },
  mounted () {
    this.getBranchtypeLst()
  },
  methods: {
    getBranchtypeLst () {
      let that = this
      api.getBranchtypeLst({}, function (res) {
        if (res.result.isSuccess === true) {
          that.branchtypeLst = res.data
          if (that.$route.query.branchtype == null || that.$route.query.branchtype === '') {
            that.branchtype = res.data[0].code
          } else {
            that.branchtype = that.$route.query.branchtype
          }

          that.getCoursewareSummaryWithPage()
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    getCoursewareSummaryWithPage (searchFlag) {
      let that = this
      that.req = {
        'courseCode': that.courseCode,
        'branchtype': that.branchtype,
        'pageSize': that.pageSize
      }
      if (searchFlag) {
        // 点击了查询按钮
        that.currentPage = 1
        if (that.agentName !== '') {
          that.req.agentName = that.agentName
        }
      }
      that.req.page = that.currentPage
      api.getCoursewareSummaryWithPage(that.req, function (res) {
        if (res.result.isSuccess === true) {
          that.tableData = res.data.data
          that.records = res.data.records
        } else {
          that.$message.error(res.result.error)
        }
      })
    },
    // 查询，每页条数更改
    handleSizeChange: function (size) {
      this.pageSize = size
      this.getCoursewareSummaryWithPage()
    },
    // 当前页数更改
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage
      this.getCoursewareSummaryWithPage()
    },
    changeBranchtype () {
      this.currentPage = 1
      this.getCoursewareSummaryWithPage(true)
      this.agentName = ''
    },
    getAssignStr (row) {
      if (row.isAssigned != null) {
        if (row.isAssigned === 0) {
          return '是'
        } else if (row.isAssigned === 1) {
          return '否'
        }
      }
    },
    exportCoursewareSummaryExcel () {
      let that = this
      api.exportCoursewareSummaryExcel(that.req, function (res) {
        if (res.result.isSuccess === true) {
          window.location.href = res.data.loadUrl
        } else {
          that.$message.error(res.result.error)
        }
      })
    }
  },
  watch: {
    '$route': {
      deep: true,
      handler: function (newVal, oldVal) {
        if (newVal.name === 'readDetailList' && newVal.query.courseCode !== oldVal.query.courseCode) {
          this.courseCode = this.$route.query.courseCode
          this.courseName = this.$route.query.courseName
          this.currentPage = 1
          this.agentName = ''
          this.getBranchtypeLst()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
 .background-white{
   background-color: #fff;
   padding:10px 1%
 }
 .item{
   margin-top: 10px;
 }
 .item-title{
  background-color: #eee;
        padding: 5px 2%;
    height: 40px;
    line-height: 40px;
 }
 .search-btn{
    float: right;
    margin-right: 1%;

 }
 .search-param{
    float: right;
    width: 30%;
 }
 .title-now{
   float: left;
   margin: 10px 1% 0 2%
 }
 .title-now img{
    height: 20px;
 }
.first-title{
  padding: 10px 2%;
  height: 40px;
  line-height: 40px
}
</style>



// WEBPACK FOOTER //
// src/pages/course/backend/readDetailList.vue